import { Button } from '@/shared/ui';
import { login } from '../model/init-keycloak';

export const LoginButton: React.FC<{ className?: string; children?: React.ReactNode }> = ({
  className,
  children = 'Войти',
}) => (
  <Button onClick={login} variant="primary" size="lg" className={className}>
    {children}
  </Button>
);
